import React from "react"

const HeadComponent = () => (
  <>
    <title>Mirai Magical School Winter Festival</title>
    <meta
      name="description"
      content="Join us in our Mirai Wonderland! Our first live concert and to make it extra special, it's a two night affair!"
    />
    <meta property="og:title" content="Mirai Magical School Winter Festival" />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://v4mirai.com/winterfest24" />
    <meta
      property="og:image"
      content="https://v4mirai.com/winterfest24/images/ogp.png"
    />
    <meta
      property="og:description"
      content="Join us in our Mirai Wonderland! Our first live concert and to make it extra special, it's a two night affair!"
    />
    <meta
      property="og:site_name"
      content="Mirai Magical School Winter Festival"
    />
  </>
)

export default HeadComponent
